import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		component: () => import("@/views/layouts/index"),
		redirect: "/home",
		meta: {
			title: "首页",
			keepAlive: false,
		},
		children: [
			{
				path: "/home",
				name: "Home",
				component: () => import("@/views/home/index"),
				meta: {
					title: "首页",
					keepAlive: false,
					metaInfo: {
						title:
							"每经品牌价值研究院-上市公司品牌价值研究及品牌数据服务引领者",
						keywords: "每经品牌价值研究院",
						description:
							"每经品牌价值研究院是由每日经济新闻联合清华大学、浙江大学、南京大学、上海交大、南开大学等10多所著名高校的品牌研究专家共同发起成立的专业品牌研究院。致力于成为中国上市公司品牌价值研究及品牌数据服务引领者。",
					},
				},
			},
			{
				path: "/valueList",
				name: "ValueList",
				component: () => import("@/views/home/valueList"),
				meta: {
					title: "品牌价值榜",
					keepAlive: true,
					metaInfo: {
						title:
							"品牌价值榜 | 每经品牌价值研究院",
						keywords: "品牌价值榜",
						description:
							"每经品牌价值研究院是由每日经济新闻联合清华大学、浙江大学、南京大学、上海交大、南开大学等10多所著名高校的品牌研究专家共同发起成立的专业品牌研究院。致力于成为中国上市公司品牌价值研究及品牌数据服务引领者。",
					},
				},
			},
			{
				path: "/brandReport",
				name: "BrandReport",
				component: () => import("@/views/home/brandReport"),
				meta: {
					title: "品牌报道",
					keepAlive: false,
					metaInfo: {
						title:
							"品牌报道 | 每经品牌价值研究院",
						keywords: "品牌报道",
						description:
							"每经品牌价值研究院是由每日经济新闻联合清华大学、浙江大学、南京大学、上海交大、南开大学等10多所著名高校的品牌研究专家共同发起成立的专业品牌研究院。致力于成为中国上市公司品牌价值研究及品牌数据服务引领者。",
					},
				},
			},
			{
				path: "/brandGuan",
				name: "BrandGuan",
				component: () => import("@/views/home/brandGuan"),
				meta: {
					title: "每经品牌观",
					keepAlive: false,
					metaInfo: {
						title:
							"每经品牌观 | 每经品牌价值研究院",
						keywords: "每经品牌观",
						description:
							"每经品牌价值研究院是由每日经济新闻联合清华大学、浙江大学、南京大学、上海交大、南开大学等10多所著名高校的品牌研究专家共同发起成立的专业品牌研究院。致力于成为中国上市公司品牌价值研究及品牌数据服务引领者。",
					},
				},
			},
			{
				path: "/listReport",
				name: "ListReport",
				component: () => import("@/views/home/listReport"),
				meta: {
					title: "榜单解读",
					keepAlive: false,
					metaInfo: {
						title:
							"榜单解读 | 每经品牌价值研究院",
						keywords: "榜单解读",
						description:
							"每经品牌价值研究院是由每日经济新闻联合清华大学、浙江大学、南京大学、上海交大、南开大学等10多所著名高校的品牌研究专家共同发起成立的专业品牌研究院。致力于成为中国上市公司品牌价值研究及品牌数据服务引领者。",
					},
				},
			},
			{
				path: "/brandTopic",
				name: "BrandTopic",
				component: () => import("@/views/home/brandTopic"),
				meta: {
					title: "品牌专题",
					keepAlive: false,
					metaInfo: {
						title:
							"品牌专题 | 每经品牌价值研究院",
						keywords: "品牌专题",
						description:
							"每经品牌价值研究院是由每日经济新闻联合清华大学、浙江大学、南京大学、上海交大、南开大学等10多所著名高校的品牌研究专家共同发起成立的专业品牌研究院。致力于成为中国上市公司品牌价值研究及品牌数据服务引领者。",
					},
				},
			},
			{
				path: "/selectActivity",
				name: "SelectActivity",
				component: () => import("@/views/home/selectActivity"),
				meta: {
					title: "评选活动",
					keepAlive: false,
					metaInfo: {
						title:
							"评选活动 | 每经品牌价值研究院",
						keywords: "评选活动",
						description:
							"每经品牌价值研究院是由每日经济新闻联合清华大学、浙江大学、南京大学、上海交大、南开大学等10多所著名高校的品牌研究专家共同发起成立的专业品牌研究院。致力于成为中国上市公司品牌价值研究及品牌数据服务引领者。",
					},
				},
			},
			{
				path: "/brandResearch",
				name: "BrandResearch",
				component: () => import("@/views/home/brandResearch"),
				meta: {
					title: "品牌价值研究院",
					keepAlive: false,
					metaInfo: {
						title:
							"品牌价值研究院 | 每经品牌价值研究院",
						keywords: "品牌价值研究院",
						description:
							"每经品牌价值研究院是由每日经济新闻联合清华大学、浙江大学、南京大学、上海交大、南开大学等10多所著名高校的品牌研究专家共同发起成立的专业品牌研究院。致力于成为中国上市公司品牌价值研究及品牌数据服务引领者。",
					},
				},
			},
		],
	},
];

const router = new VueRouter({
	routes,
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
});

// router.beforeEach((to, from, next) => {
//   next()
// })

export default router;
